import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  hint: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.colorPalette.white,
    fontSize: 11
  }
});

export default makeStyles(styles);
